/**
 *
 * Contact Information
 *
 */

import React, {Component} from 'react';
import Helmet from 'react-helmet';

// Components
import Loading from '../components/general/Loading';
import Error from '../components/general/Error';

/* Component ==================================================================== */
class Terms extends Component {

  showEmailAddress = () => {
    this.setState({showEmail: true});
  };

  render = () => {

    const {loading, error, showEmail} = this.state;

    if (loading) return <Loading/>;
    if (error) return <Error text={error}/>;

    return (
      <div className="index screen-container">
        <Helmet>
          <title>About us</title>
        </Helmet>

        <div className={'main-container container'}>
          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-8 col-md-10'}>
              <h1 className={'text-center'}>About Renzo</h1>
            </div>
          </div>
          <div className={'spacer-20'}/>
          <div className={'row justify-content-md-center'}>
            <div className={'col-sm-12 col-lg-8 col-md-10'}>
              <h4>We're bunch of people out to build great products!</h4>
              <div className={'spacer-20'}/>

              <p>Truth is most people hate the software they use at work the enterprise ones, because they use
                inappropriate software which packs a set boring tasks to operate.</p>

              <p>Property Management software is clunky, expensive, hard to setup and frustrating to use. Countless
                hours are wasted to customize these solutions for every single business and they often require expensive
                professional services to get everything to work.</p>

              <p>We believe your business needs better software - one that's ready to do and works intuitively with your
                routine business process and requires minimal customization. All our products live up to this promise
                and is backed with best in class support. The best part is, you don’t have to empty your bank to get
                these working.</p>

              <div className={'spacer-20'}/>
              <div className={'row'}>
                <div className={'col-sm-12 col-md-6'}>
                  <p>You can also e-mail to&nbsp;
                    {showEmail === true ? <span>r@renzo.in or support@renzo.in</span> :
                      <span onClick={() => this.showEmailAddress()} className={'ul link'}><u>Click to See email
                        address.</u></span>}</p>
                </div>

                <div className={'col-sm-12 col-md-6'}>
                  <h5>Mailing address</h5>
                  <p>
                    Renzo Solutions Inc<br/>
                    2035 Sunset Lake Road,<br/>
                    Newark 19702
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      showEmail: false
    };
  }

}

export default Terms;


// WEBPACK FOOTER //
// ./src/containers/About.js